import Reveal from "@/components/Reveal";
import Monogram from "@/components/Monogram";
import { Link } from "react-router-dom";
import { ABOUT_IMAGE, FEATURED_IMAGE } from "@/content/site";

export default function About() {
  return (
    <>
      <section className="pt-44 pb-16 px-6 lg:px-14 bg-[#F5F2ED] relative overflow-hidden">
        <Monogram size={760} opacity={0.05} color="#4A3E39" className="absolute -left-60 top-0 hidden md:block" />
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-6">About</div>
            <h1 className="font-display font-light text-ivory-800 text-6xl md:text-8xl lg:text-[120px] leading-[0.95] max-w-5xl">
              We <em className="italic">refuse</em>
              <br />
              the emergency.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-14 py-20 lg:py-32 bg-[#F5F2ED]">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-6">
            <div className="zoom-wrap aspect-[4/5] overflow-hidden">
              <img src={ABOUT_IMAGE} alt="Studio" className="zoom-img w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-6 lg:pl-10 lg:pt-20" delay={120}>
            <div className="space-y-7 text-[16px] leading-[1.95] text-ivory-700">
              <p>
                T&amp;S Ivory began in 2021, in a single rented room above a bookshop in Pali Hill.
                Twelve square metres. One window. One mirror. A wooden chair we still use.
              </p>
              <p>
                We were three then — a colourist, a hairdresser, and a friend who happened to know
                quite a lot about skin. Three years later, we are still small enough to remember
                everyone&rsquo;s name, and large enough to be open six days a week.
              </p>
              <p>
                What has not changed: we see fewer guests in a day than most salons see in an hour.
                We refuse the bright lights. We refuse the music. We refuse the small, false
                hurriedness that has come to define modern beauty.
              </p>
              <p>
                What you find inside is the opposite of that — travertine, linen, raw oak,
                a long northern window, and an unusual amount of silence. The interior, we believe,
                is the first treatment.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="relative h-[70vh] min-h-[480px] overflow-hidden">
        <img src={FEATURED_IMAGE} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C2724]/35" />
        <div className="absolute inset-0 flex items-center justify-center px-6">
          <Reveal>
            <p className="font-display italic text-ivory-100 text-3xl md:text-5xl lg:text-6xl text-center max-w-4xl leading-tight">
              &ldquo;The interior is the first treatment.&rdquo;
            </p>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-14 py-28 lg:py-40 bg-[#EEE7DE]">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-4">
            <div className="eyebrow mb-3">Our Practice</div>
            <h2 className="font-display font-light text-ivory-800 text-4xl md:text-5xl">Three quiet rules.</h2>
          </Reveal>
          {[
            { n: "01", t: "Subtraction", b: "We will always remove before we add. Skincare, hair, makeup — fewer steps, better steps." },
            { n: "02", t: "Memory", b: "Every guest is remembered. Notes are kept by hand. The colour that worked in March is still on file in October." },
            { n: "03", t: "Daylight", b: "We work in daylight wherever possible. The room your colourist sees you in is the room you will live in tomorrow." },
          ].map((r, i) => (
            <Reveal key={r.n} className="lg:col-span-3" delay={i * 100}>
              <div className="font-display italic text-[#6D1F2B] text-3xl">{r.n}</div>
              <h3 className="mt-3 font-display text-2xl text-ivory-800">{r.t}</h3>
              <p className="mt-4 text-[14px] leading-[1.85] text-ivory-700">{r.b}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-6 lg:px-14 py-24 bg-[#F5F2ED] text-center">
        <Reveal>
          <Link to="/book" data-testid="about-book-cta" className="btn-burgundy">Book a consultation</Link>
        </Reveal>
      </section>
    </>
  );
}
